/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Reminder } from '@shared/models';
import { CurrentDateService } from '@shared/services/current-date.service';

@Component({
    selector: 'app-reminder-details',
    templateUrl: './reminder-details.component.html',
    styleUrls: ['./reminder-details.component.scss'],
    standalone: false
})
export class ReminderDetailsComponent implements OnInit {
  originalDate: Date;
  @Input()
  formGroup: UntypedFormGroup;

  constructor(private currentDateService: CurrentDateService) { }

  isValidDate = (date: Date | null): boolean => {
    if (!date) {
      return false;
    }
    date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return date >= this.currentDateService.getCurrentDate() || (this.originalDate && date.valueOf() === this.originalDate.valueOf());
  }

  ngOnInit(): void {
    const reminderDate = this.formGroup.get('date').value;
    if (reminderDate) {
      const date = new Date(reminderDate);
      this.originalDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
  }
}
